import { render, staticRenderFns } from "./editQuotesAndInvoices.vue?vue&type=template&id=5c788a8e&scoped=true&"
import script from "./editQuotesAndInvoices.vue?vue&type=script&lang=js&"
export * from "./editQuotesAndInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c788a8e",
  null
  
)

export default component.exports